import * as React from 'react';
import { FC } from 'react';

import { Menu, MenuItem } from '@mui/material';
import { Trash2, Edit3 } from 'react-feather';

interface SchedulerActionMenuProps {
  onClickEdit: () => void;
  onClickDelete: () => void;
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
}

export const SchedulerActionMenu: FC<SchedulerActionMenuProps> = ({
  onClickEdit,
  onClickDelete,
  onClose,
  open,
  anchorEl,
}) => {
  return (
    <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem onClick={onClickEdit}>
        <Edit3 size={16} style={{ marginRight: 10 }} />
        Edit Scheduler
      </MenuItem>
      <MenuItem onClick={onClickDelete}>
        <Trash2 size={16} style={{ marginRight: 10 }} />
        Delete Scheduler
      </MenuItem>
    </Menu>
  );
};
